<template >
    <div class="right_box_main">
        <div class="listBox-item">
            
            <el-card>
                <div class="fisthang">
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item label="物业企业名称" style="margin:0 30 0 0;">
                            <el-input
                                v-model="searchlist.questionDescribe"
                                placeholder="请输入物业企业名称"
                                style="width:120px;"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdata">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="listBox-item">
                    <el-button
                        style="margin-bottom:20px"
                        type="primary"
                        size="mini"
                        @click="showDialog('','add')"
                    >新增</el-button>
                    <!-- 表格盒子 -->
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="partyName" label="纠纷类型"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="创建人"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="创建日期"></el-table-column>

                            <el-table-column align="center" label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="查看"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-chakan tabBtn tabBtnCk"
                                            @click="showDialog(scope.row,'delete')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="删除"
                                        placement="top-start"
                                    >
                                        <button
                                            class="tabBtn el-icon-delete tabBtn-delete"
                                            @click="showDialog(scope.row,'delete')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="修改"
                                        placement="top-start"
                                    >
                                        <button
                                            @click="showDialog(scope.row,'update')"
                                            class="tabBtn el-icon-edit-outline tabBtn-edit"
                                        ></button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                    </div>

                    <el-dialog :title="add.title" :visible.sync="add.off" width="1100px">
                        <el-form
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            label-width="120px"
                        >
                            <el-form-item label="物业企业名称" prop="partyName">
                                <el-input type="text" v-model="add.form.partyName"></el-input>
                            </el-form-item>
                            <el-form-item label="资质等级">
                                <el-select v-model="searchlist.activeStatus" placeholder="请选择">
                                    <el-option label="待处理" value="1"></el-option>
                                    <el-option label="处理中" value="2"></el-option>
                                    <el-option label="已处理" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="服务内容">
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="复选框 A"></el-checkbox>
                                    <el-checkbox label="复选框 B"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="负责人">
                                <el-input type="text" v-model="add.form.partyName"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话">
                                <el-input type="text" v-model="add.form.partyName"></el-input>
                            </el-form-item>
                            <el-form-item label="企业地址" prop="address">
                                <mapLocation
                                    :data="add.form.address"
                                    :disabled="false"
                                    :on-success="mapSuccess"
                                    v-if="mapOff"
                                ></mapLocation>
                            </el-form-item>
                            <el-form-item label="企业图片" prop="address">
                                <upimg v-model="add.form.img" />
                            </el-form-item>
                            <el-form-item label="企业介绍" prop="address">
                                <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                            </el-form-item>
                            <el-form-item label="服务小区" prop="address">
                                <el-select v-model="searchlist.activeStatus" placeholder="请选择">
                                    <el-option label="待处理" value="1"></el-option>
                                    <el-option label="处理中" value="2"></el-option>
                                    <el-option label="已处理" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">立即{{add.title}}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-dialog>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import { tabdata } from "@/mixins/tabledataMix.js";
import { validatePhoneOrMobile } from "@/utils/validate.js";
import mapLocation from "@/components/mapLocation";
import upimg from "@/components/uploadImg";
export default {
    mixins: [tabdata],
    components: { mapLocation,upimg },
    data() {
        var checkMap = (rule, value, callback) => {
            if (this.add.form.address.addressDetail) {
                callback();
            } else {
                callback(new Error("请选择地址"));
            }
        };
        return {
            ruleArr: {
                partyName: [
                    {
                        required: true,
                        message: "请输入政府名称",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        validator: checkMap,
                        required: true,
                        trigger: "change"
                    }
                ]
            },
            add: {
                form: {},
                off: false
            },
            type: "",
            mapOff: true,
            mapData: {
                // addressDetail:
                //     "安徽省池州市贵池区池州市火车站站前区七星路池州碧桂园",
                // areaId: 3,
                // cityId: 2,
                // latitude: 30.622313,
                // longitude: 117.502714,
                // streetId: 4,
            }
        };
    },
    methods: {
        onSubmit() {
            this.$refs.baseForm.validate(valid => {
                if (valid) {
                    if (this.type == "add") {
                        post(
                            "/admin/livelihoodsDisability/info/insertPartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("新增成功");
                            this.getPageDatas();
                        });
                    } else {
                        post(
                            "/admin/livelihoodsDisability/info/updatePartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("修改成功");
                            this.getPageDatas();
                        });
                    }
                } else {
                    //   console.log("error submit!!");
                    return false;
                }
            });
        },
        showDialog(row, type) {
            this.mapOff = false;
            this.$nextTick(() => {
                this.mapOff = true;
            });
            this.type = type;
            switch (type) {
                case "add":
                    this.add.off = true;
                    this.add.title = "新增";
                    this.add.form = {};
                    break;
                case "delete":
                    this.$confirm("此操作将删除该热线, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        post(
                            "/admin/livelihoodsDisability/info/deletePartyPhone",
                            {
                                id: row.id
                            }
                        ).then(res => {
                            this.$message({
                                type: "success",
                                message: "删除该热线成功"
                            });
                            this.getPageDatas();
                        });
                    });
                    break;
                case "update":
                    this.add.off = true;
                    this.add.title = "修改";
                    this.add.form = JSON.parse(JSON.stringify(row));
                    break;
            }
        },
        mapSuccess(info) {
            this.add.form.address = info;
        }
    },
    mounted() {
        // this.initTableDataUrl(
        //     "/admin/livelihoodsDisability/info/listPartyPhone"
        // );
    },
    created() {}
};
</script>

<style lang="less" scoped>
.icon-chakan {
    color: #199b5d;
}
</style>
 